import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, watch } from "vue";
import { integrationsStore, jiraApiStore } from "@/hooks";
import { SelectInput } from "@/components/common";
import { JiraAuthentication } from "@/components/integrations/authentication";


/**
 * Allows for selecting a GitHub repository.
 */
const __default__ = {
  name: "GitHubProjectInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const organizationName = computed(
  () => integrationsStore.jiraOrganization?.name
);

/**
 * Loads a user's GitHub projects for a selected organization.
 */
function handleReload() {
  if (!integrationsStore.jiraOrganization) return;

  jiraApiStore.handleLoadProjects();
}

onMounted(() => handleReload());

watch(
  () => organizationName.value,
  () => handleReload()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(integrationsStore).validJiraCredentials)
      ? (_openBlock(), _createBlock(_unref(JiraAuthentication), { key: 0 }))
      : (_openBlock(), _createBlock(_unref(SelectInput), {
          key: 1,
          modelValue: _unref(integrationsStore).jiraOrganization,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(integrationsStore).jiraOrganization) = $event)),
          label: "Jira Organization",
          options: _unref(jiraApiStore).organizationList,
          loading: _unref(jiraApiStore).loading,
          hint: "Required",
          class: "full-width",
          "option-label": "name",
          "data-cy": "input-github-organization"
        }, null, 8, ["modelValue", "options", "loading"])),
    (!!_unref(integrationsStore).jiraOrganization)
      ? (_openBlock(), _createBlock(_unref(SelectInput), {
          key: 2,
          modelValue: _unref(integrationsStore).jiraProject,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(integrationsStore).jiraProject) = $event)),
          label: "Jira Project",
          options: _unref(jiraApiStore).projectList,
          hint: "Required",
          class: "full-width",
          "option-label": "name",
          "data-cy": "input-github-project"
        }, null, 8, ["modelValue", "options"]))
      : _createCommentVNode("", true)
  ]))
}
}

})